import {getActiveValuesByBookmarkPresentationID} from "@/helpers/layer/overview/layer-overview-domain-list-helper";

/**
 * Get the OGC filter for the given bookmark presentation ID
 *
 * @param bookmarkPresentationID
 * @param propertyName
 * @param filter : extra OGC filter
 * @param withFilterParams
 * @returns {string}
 */
export function getOgcInFilter(bookmarkPresentationID, propertyName, filter = '', withFilterParams = true) {

    const values = getActiveValuesByBookmarkPresentationID(bookmarkPresentationID)

    let literals = ''
    let nullValue = ''
    values.map(value => {
        if(propertyName && value === '') {
            nullValue = `<ogc:PropertyIsNull><ogc:PropertyName>${propertyName}</ogc:PropertyName></ogc:PropertyIsNull>`
        } else {
            literals += `<ogc:Literal>${value}</ogc:Literal>`
        }
    })

    let filterAnd = ''

    if(filter) {
        if(propertyName) {
            filterAnd = '</ogc:And>'
            filter = `<ogc:And>${filter}`
        } else {
            filter = `${filter}`
        }
    }

    if(literals && nullValue) {
        nullValue += '</ogc:Or>'
        filter += '<ogc:Or>'
    } else if(nullValue) {
        nullValue = `<ogc:Filter>${nullValue}</ogc:Filter>`
    }

    if(!literals && !nullValue) {
        literals = `<ogc:Literal></ogc:Literal>`
    }

    let propertyNameFilter = ''
    if(propertyName && literals) {
        propertyNameFilter = `<ogc:PropertyIsEqualTo><ogc:Function name="in"><ogc:PropertyName>${propertyName}</ogc:PropertyName>${literals}</ogc:Function><ogc:Literal>true</ogc:Literal></ogc:PropertyIsEqualTo>`
    }

    let result = `${filter}${propertyNameFilter}${nullValue}${filterAnd}`
    if(withFilterParams) {
        return `<Filter xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc">${result}</Filter>`
    }
    return result



}
